export const GAODEMAP_AIP = 'e215a1d372cf0f28d8013943d4928d59';
export const BAIDUMAP_AIP = 'hAe9t6yjFR7v6KWUFG96DI1M';
export const LOGIN_SIGN_KEY = 'FD3910CB340E09CD9096F7E1059661B2';
export const LOGIN_URL = 'http://cis.cn-hunicorn.com/ThridLogin/LoginForUser';
export const REGISTER_URL = 'http://cis.cn-hunicorn.com/CustomerRegist/NewRegist';
export const FORGOT_PASSWORD_URL = 'http://cis.cn-hunicorn.com/CustomerRegist/ResetPassword';



// WEBPACK FOOTER //
// ./src/config/index.js